<script lang="ts" setup>
import MultiuczynekItems from '@/domains/esg/key-activities/components/Multiuczynek/MultiuczynekItems.vue'
import { useKeyActivities } from '@/domains/esg/composables/content/useKeyActivities'

const { multiuczynekItems } = useKeyActivities()
</script>

<template>
  <UiSection
    id="multiuczynek"
    class="multiuczynek"
    color="gray"
  >
    <img
      class="multiuczynek__logo"
      alt="Fundacja Multisport"
      src="/images/key-activities/multiuczynek-logo.png"
    >

    <UiHeader
      subheader-size="h7"
      :header="''"
      :subheader="$t('keyActivities.multiuczynek.subheader')"
    />

    <MultiuczynekItems :items="multiuczynekItems" />
  </UiSection>
</template>

<style lang="scss" scoped>
.multiuczynek {
  padding-top: 3.2rem;
  padding-bottom: 2.4rem;

  :deep(.ui-header) {
    margin: 1.6rem auto;
  }

  :deep(.ui-header__subheader) {
    @include h8;
    margin: 1.6rem auto;
    
    br {
      display: none;
    }
  }

  &__logo {
    display: block;
    margin: 0 auto 1.6rem auto;
  }

  &__button {
    margin: 7.2rem auto 0;
  }

  @include atM {
    padding-top: 9.6rem;
    padding-bottom: 2.4rem;

    :deep(.ui-header) {
      margin: 4.8rem auto;
    }

    :deep(.ui-header__subheader) {
      @include h7;
      margin: 4.8rem auto;
      
      br {
        display: inline;
      }
    }
  }
}
</style>
